<template>
    <!-- 发布 -->
    <div class="">
      <v-dialog
        class="del"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitleyes"
        close-on-click-modal
        :modal="true"
        :width="668"
        :height="274"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
        v-bind:confirmButtonText= "this.sure"
      >
      <span> {{  '确定要发布物模型吗？'}}</span>
      </v-dialog>
    </div>
</template>

  <script>
  export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    productKey:{
    },
    productId:{
    },


    },
    data() {
      return {
        sure:"确认",

        isShow:false,
        dialogTitleyes: "确认发布产品",
      };
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      open(){

      },
      handleConfirm() {
        const subData = {
          product_id: Number(this.productId),
          product_key: this.productKey
        };
        this.$post(`/td/td-iot-api/iot/thing/draft/publish/v1`, subData ,false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
      this.$emit('getData')
      this.$emit('update:showInputDialog',false)
      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
